module.exports = __webpack_public_path__ + "static/banner-tablet-990721ebbd2f2b0017dffa2ab31bcecf.png";